import { ChangeDetectorRef, Component, Input } from '@angular/core';
import { CCREditMaterialLine } from '../../../core/store/edit-ccr-detail/ccr-detail.interface';
import { MaterialTypes } from '../../../core/store/contract-details/contract-details.interface';
import { FlorderMaterialLinesComponent } from '../../florder/florder-material-lines/florder-material-lines.component';
import { LayoutBreakpoints } from '../../../core/util/layout-breakpoints';
import { BreakpointObserver } from '@angular/cdk/layout';

@Component({
  selector: 'app-ccr-material-lines',
  templateUrl: './ccr-material-lines.component.html',
  styleUrls: ['../../florder/florder-material-lines/florder-material-lines.component.scss'],
})
export class CCRMaterialLinesComponent extends FlorderMaterialLinesComponent<CCREditMaterialLine> {
  @Input() palletQuantity: number;
  @Input() title: string;
  @Input() materialTypes: MaterialTypes;

  constructor(breakpointObserver: BreakpointObserver, cd: ChangeDetectorRef) {
    super(breakpointObserver, cd);
  }
}
